// extracted by mini-css-extract-plugin
export var button = "_di-4";
export var hasDarkBackground = "_di-7";
export var hasLightBackground = "_di-6";
export var iconWrapper = "_di-0";
export var large = "_di-2";
export var medium = "_di-1";
export var small = "_di-5";
export var xsmall = "_di-3";